import React, { Component } from 'react';
import '../../Common/shared.css'
import '../style.css';

import T from 'i18n-react';
import InterviewTitleProgress from '../../Common/interviewTitleProgress'
import { isValidMessage } from '../../Register/services/registrationUtils';

class InterviewPage11 extends Component {
    constructor(props) {
        super(props)

        this.state = {
            notes: this.props.notes || '',
            lang: this.props.lang,
            notesError: ''
        }
    }

    validateNotes(value) {
        if (!value || value.trim().length === 0) {
            return '';
        }
        
        if (!isValidMessage(value)) {
            return T.translate("Common.Errors.InvalidNameChars");
        }
        
        return '';
    }

    onTextChange(ev) {
        let notes = {
            ...this.state.notes
        }
        notes = ev.target.value;
        const notesError = this.validateNotes(notes);
        
        this.setState({ notes, notesError });

        if (this.props.onNotesChanged) {
            this.props.onNotesChanged(notes)
        }
    }

    componentWillReceiveProps(newProps) {        
        if (this.state.notes !== newProps.notes) {
            const notesError = this.validateNotes(newProps.notes);
            this.setState({ notes: newProps.notes, notesError })
        }
        if (this.state.lang !== newProps.lang) {
            this.setState({ lang: newProps.lang })
        }
    }

    componentDidMount() {
        const notesError = this.validateNotes(this.state.notes);
        if (notesError !== this.state.notesError) {
            this.setState({ notesError });
        }
    }

    render() {
        var percentage = '90'
        if (this.props.saving === true) {
            percentage = '100'
        }

        return (
            <div>
                <div style={{ margin: 'inherit 20px' }}>
                    <div>
                        <InterviewTitleProgress taxYear={this.props.taxYear} percentage={percentage} title="Interview.Page11.headerTitle" noNextTitle="true" />
                    </div>
                    <div className= "interview-page11-top-margin">
                        <T.text tag='p' text="Interview.Page11.headerContent0" className="headerText" />
                    </div>
                    <div className="defaultStyles">
                        <textarea 
                            style={{ fontSize: '16px', borderColor: this.state.notesError ? 'red' : '' }} 
                            onChange={(ev) => this.onTextChange(ev)} 
                            value={this.state.notes}
                            maxLength={1000}
                        />
                        {this.state.notesError && (
                            <div style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>
                                {this.state.notesError}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}


export default InterviewPage11;
